export const getUserMarkedHelpful = (userId, review) => {
  return review && review.get('attributes').some(attr => (attr.get('userId') === userId || attr.get('userId') === Number(userId)) && attr.get('helpful'));
};